module.exports = __webpack_public_path__ + "static/forecast/temperature/cold-a0879b602413d4d68baaaf213478aa3b.svg";